import React from "react";

const Footer = ({ note }) => (
  <footer className="qp-footer">
    <div className="qp-footer-line" />
    <p>{note || "All the Best!"}</p>
    <p className="qp-end">— End of Question Paper —</p>
  </footer>
);

export default Footer;
